import React from 'react';
import { Dialog, IconButton, Typography, DialogContent } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import styled from 'styled-components';
import ButtonComponent from '../buttton'; // make sure the path is correct

const StyledDialog = styled(Dialog)`
  .MuiDialog-paper {
    padding: 0;
    border-radius: 20px;
    max-width: 400px;
    width: 90%;
    margin: 16px;
    text-align: center;
    position: relative;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
    
    @media (max-width: 480px) {
      max-width: 350px;
      width: 95%;
      margin: 8px;
      border-radius: 16px;
    }
  }

  .MuiBackdrop-root {
    background-color: rgba(0, 0, 0, 0.4);
  }
`;

const CloseButton = styled(IconButton)`
  position: absolute !important;
  top: 16px;
  right: 16px;
  z-index: 1;
  padding: 8px !important;
  color: #999 !important;
  
  &:hover {
    background-color: rgba(0, 0, 0, 0.04) !important;
    color: #666 !important;
  }

  @media (max-width: 480px) {
    top: 12px;
    right: 12px;
    padding: 6px !important;
  }
`;

const ContentContainer = styled(DialogContent)`
  padding: 48px 32px 32px 32px !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  
  @media (max-width: 480px) {
    padding: 40px 24px 24px 24px !important;
  }
  
  @media (max-width: 360px) {
    padding: 36px 20px 20px 20px !important;
  }
`;

const Title = styled(Typography)`
  font-size: 20px !important;
  font-weight: 600 !important;
  color: #1a1a1a !important;
  margin-bottom: 16px !important;
  font-family: 'Urbanist', -apple-system, BlinkMacSystemFont, sans-serif !important;
  line-height: 1.3 !important;
  
  @media (max-width: 480px) {
    font-size: 18px !important;
    margin-bottom: 14px !important;
  }
  
  @media (max-width: 360px) {
    font-size: 16px !important;
    margin-bottom: 12px !important;
  }
`;

const Description = styled(Typography)`
  font-size: 14px !important;
  color: #666666 !important;
  margin-bottom: 32px !important;
  line-height: 1.5 !important;
  font-family: 'Urbanist', -apple-system, BlinkMacSystemFont, sans-serif !important;
  max-width: 280px;
  
  @media (max-width: 480px) {
    font-size: 13px !important;
    margin-bottom: 28px !important;
    max-width: 100%;
  }
  
  @media (max-width: 360px) {
    font-size: 12px !important;
    margin-bottom: 24px !important;
  }
`;

const RejectButton = styled.button`
  width: 100%;
  max-width: 200px;
  padding: 12px 24px;
  background-color: white;
  color: #CC0000;
  border: 1px solid #CC0000;
  border-radius: 25px;
  font-family: 'Urbanist', -apple-system, BlinkMacSystemFont, sans-serif;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  
  &:hover {
    background-color: #CC0000;
    color: white;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(204, 0, 0, 0.2);
  }
  
  &:active {
    transform: translateY(0);
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
  
  @media (max-width: 480px) {
    max-width: 180px;
    padding: 10px 20px;
    font-size: 13px;
    min-height: 40px;
  }
  
  @media (max-width: 360px) {
    max-width: 160px;
    padding: 8px 16px;
    font-size: 12px;
    min-height: 36px;
    border-radius: 20px;
  }
`;

const LoaderSpinner = styled.div`
  width: 16px;
  height: 16px;
  border: 2px solid transparent;
  border-top: 2px solid currentColor;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-right: 8px;
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  
  @media (max-width: 480px) {
    width: 14px;
    height: 14px;
    margin-right: 6px;
  }
`;

const ConfirmRejectModal = ({ open, onClose, onConfirm, loader }) => {
  return (
    <StyledDialog 
      open={open} 
      onClose={!loader ? onClose : undefined}
      disableEscapeKeyDown={loader}
    >
      <CloseButton
        onClick={onClose}
        disabled={loader}
        size="small"
      >
        <CloseIcon fontSize="small" />
      </CloseButton>
      
      <ContentContainer>
        <Title>
          Are You Sure You Want <br /> to Reject This <br /> Recommendation?
        </Title>
        
        <Description>
          This action will permanently remove the recommendation from the platform. The employee will be notified of the rejection.
        </Description>

        <ButtonComponent
          onClick={onConfirm}
          loader={loader}
          name="Reject"
          styles={{
            backgroundColor: "white",
            color: "#CC0000",
            border: "1px solid #CC0000",
          }}
        />
      </ContentContainer>
    </StyledDialog>
  );
};

export default ConfirmRejectModal;